import http from "@/settings/apiSettings"

class PRO_CategoriiDataService{
    save(data: any): Promise<any> {
        return http.clientComercialOdata.post("/PRO_Categorii", data);
    }
    
}
export default new PRO_CategoriiDataService();